'use strict';

import React, { Component, Fragment } from 'react';
import ValidationOverlay from '../../Menu/validationOverlay';

import Select from 'react-select';
import PopUp from '../../../commonModules/interface/PopUp';
import { Box, Grid } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../commonModules/interface/form-input-inline';
import {TextField} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const listStatus = [
  {label: "SMS - Unique avant retard", value: "upcoming_payment"},
  {label: "SMS - Après retard", value: "payment_delay"},
  {label: "SMS - Inscription", value: "inscription"},
  {label: "SMS - Confirmation de Paiement", value: "payment"},
  {label: "SMS - Fin de Paiement", value: "Final_payment"},
]

class ChooseTypeOfAlert extends Component {
  render () {
      return (
          <div>
              <InputSelect
                  options={listStatus}
                  // className="form-control"
                  name="alertType"
                  value={this.props.alertType}
                  label="Choisissez un type d'alerte"
                  onChange={ this.props.handleSelect }
                  // style={{border: '0'}}
                  // selectedValue={this.state.status}
              />
              {/* <Select
                  options={listStatus}
                  className="form-control"
                  name="alertType"
                  value={this.props.alertType}
                  placeholder="Choisissez une type d'alerte"
                  onChange={ this.props.handleSelect }
                  style={{border: '0'}}
                  // selectedValue={this.state.status}
              /> */}
          </div>
      )
  } 
}

class ChooseSubscription extends Component {
  render () {
      let subscriptionList = [];
      subscriptionList.push({label: 'Tous les abonnements', value: 'ALL'})
      console.log("[INFO], ChooseSubscription, ",this.props.SUBSCRIPTIONS)
      if (this.props.SUBSCRIPTIONS){

        Object.keys(this.props.SUBSCRIPTIONS).map((zone)=>(
          subscriptionList.push({label: this.props.SUBSCRIPTIONS[zone].name, value: this.props.SUBSCRIPTIONS[zone].id})
            ))    
      }
      console.log("[INFO], ChooseSubscription, ",subscriptionList)
      return (
          <div>
              <InputSelectMagasin
                  options={subscriptionList}
                  // className="form-control"
                  label="Choisissez les abonnements éligibles"
                  name="subscription"
                  value={this.props.susbcriptionList}
                  placeholder="Choisissez les abonnements éligibles"
                  onChange={ this.props.handleSelect }
                  // style={{border: '0',overflow: 'auto'}}
                  // selectedValue={this.state.status}
              />
              {/* <Select
                  options={subscriptionList}
                  className="form-control"
                  name="subscription"
                  value={this.props.susbcriptionList}
                  placeholder="Choisissez les abonnements éligibles"
                  onChange={ this.props.handleSelect }
                  style={{border: '0',overflow: 'auto'}}
                  // selectedValue={this.state.status}
              /> */}
          </div>
      )
  }
} 

class NewAlertManagement extends Component{

    state ={
        //Initiate Default User
        msg: "",
        popupStateValidation: false,
        alertType:"",
        // alertType:{name: "",value:""},
        susbcriptionList: "",
        // susbcriptionList: {name: "",value:""},
        message: "",
        alertName: "",
        errmsg: "",
        info: "",
        info2: "",
        url: "",
    }
    onValidation= async (e) => {
        e.preventDefault();
        //Test if ok
        if (this.state.alertName === ''){
          this.setState({errmsg: "Le Nom de l'alerte ne peut être vide"});
          return;
        }
        if (this.state.message === ''){
          this.setState({errmsg: "Le message ne peut être vide"});
          return;
        }
        if (this.state.alertType.label === ''){
          this.setState({alertType: "Le Type d'alert ne peut être vide"});
          return;
        }
        if (this.state.susbcriptionList.label === ''){
          this.setState({errmsg: "L'abonnement ne peut être vide"});
          return;
        }
        console.log(this.state.alertType );
        console.log(this.state.susbcriptionList );
        var msg = "Enregistrement ALERTE; Type  : "+this.state.alertType.label + ", nom : "+this.state.alertName+" , Abonnement  :"+this.state.susbcriptionList.label+ ", message  : "+this.state.message;
        var url = "/alerts/new?name=" + this.state.alertName + "&type=" + this.state.alertType.value +"&sub=" + this.state.susbcriptionList.value + "&message=" + this.state.message+ "&info=" + this.state.info+ "&info2=" + this.state.info2;
        //Active Pop up Security
        this.setState({popupStateValidation: true, msg:msg,url:url});
    }
    onCancelation= (e) => {
      this.setState({popupStateValidation:false});
    }
    onValidationSucceed= (e) => {
      this.setState({ popupStateValidation:false});
      this.props.onCloseOverlay();
    }
    onClose= async (e) => {
      e.preventDefault();
      this.setState({ popupStateValidation:false});
      this.props.onCloseOverlay();
    }

    handleChange = (e) => {
      const { label, value } = e.target;  
      console.log("[INFO], handleChange , ",label, " for ",value)
      this.setState({
          [label]: value
      })
  }

    render() {
        return (
			<Box>
				<PopUp 
				  title="Nouvelle Alerte"
				  submitAction={this.onValidation}
				  close={this.onClose}
				>  
					<Grid container spacing={2} >
						<Grid item xs={12}>
              <InputText
                label="Nom Alerte"
							  value={this.state.alertName} 
                onChange={ (e) => this.setState({alertName:e.target.value}) }
              />
						</Grid>
	
						<Grid item xs={12}>
							{/* <p className="c-black f-500 m-b-20">Abonnement</p>
							<div className="form-group"> */}
								<ChooseSubscription 
									{...this.props} 
									{...this.state}
									handleChange={this.handleChange} 
									handleSelect={ option => this.setState({ susbcriptionList: option}) }  
								/>
							{/* </div> */}
						</Grid>
						<Grid item xs={12}>
							{/* <p className="c-black f-500 m-b-20">Type d'alerte</p>
							<div className="form-group"> */}
								<ChooseTypeOfAlert 
									{...this.state} 
									handleChange={this.handleChange} 
									handleSelect={ option => {this.setState({ alertType: option})} }  
								/>
							{/* </div> */}
						</Grid>
						{this.state.alertType.value  == "upcoming_payment" &&
						<Grid item xs={12}>
							{/* <p className="c-black f-500 m-b-20">Nombre de Jour avant fin abonnement</p>
							<div className="form-group">
								<div className="fg-line">
								<input type="number" className="form-control fg-input" value={this.state.info} onChange={(e) =>  this.setState({info: e.target.value})} />
								</div>
							</div> */}
              <InputText
                label="Nombre de Jour avant fin abonnement"
                value={this.state.info} 
                onChange={(e) =>  this.setState({info: e.target.value})}
              />
						</Grid>
						}
						{this.state.alertType.value  == "payment_delay" &&
						<Fragment>
							<Grid item xs={12}>
								{/* <p className="c-black f-500 m-b-20">Debut période</p>
								<div className="form-group">
									<div className="fg-line">
									<input type="number" className="form-control fg-input" value={this.state.info} onChange={(e) => this.setState({info:e.target.value})} />
									</div>
								</div> */}
                <InputText
                  label="Début Période"
                  value={this.state.info} 
                  onChange={(e) => this.setState({info: e.target.value})}
                />
							</Grid>
							<Grid item xs={12}>
								{/* <p className="c-black f-500 m-b-20">Fin période</p>
								<div className="form-group">
									<div className="fg-line">
									<input type="number" className="form-control fg-input" value={this.state.info2} onChange={(e) => {this.setState({info2:e.target.value})}}/>
									</div>
								</div> */}
                <InputText
                  label="Fin Periode"
                  value={this.state.info2} 
                  onChange={(e) => {this.setState({info2:e.target.value})}}
                />
							</Grid>
						</Fragment>
						}
						<Grid item xs={12}>
							{/* <p className="c-black f-500 m-b-20">Message</p>
							<div className="form-group">
								<div className="fg-line">
								<input type="text" className="form-control fg-input" value={this.state.message} />
								</div>
							</div> */}
              <InputText
                // style={{width:"100%"}}
                // margin="normal"
                // variant="outlined"  
                label="Message"
                value={this.state.message}
                placeholder="Message"
                onChange={(e) => {this.setState({message:e.target.value})}}
                rows={3}
            />
						</Grid>
					  <Grid item xs={12}>
            {this.state.errmsg &&
              <Alert severity="error">
                {this.state.errmsg}
              </Alert>
            }
            </Grid>
						<Grid item xs={12}>
              <Alert severity="info">
                client_name := "Nom du Client"
                <br></br>
                days_overdue := "Nombre de jour de retard"
                <br></br>
                next_payment := "Montant du prochain paiement"
                <br></br>
                total_amount := "Montant total de l'abonnement"
                <br></br>
                amount_paid := "Paiement"
                <br></br>
                rest_topay := "Restant à payer"
                <br></br>
                id_product := "ID produit"
                <br></br>
                code_product := "Code"
              </Alert>
						</Grid>
					</Grid>
				</PopUp>
				{this.state.popupStateValidation &&
					<ValidationOverlay 
						msg={this.state.msg} 
						popupStateButton={this.state.popupStateValidation} 
						url={this.state.url} 
						onValidation={this.onValidationSucceed} 
						onCancelation={this.onCancelation} 
						{...this.props}
					/>
				}
			</Box>
        );
    }
};
export default NewAlertManagement
